import { combineReducers } from "redux";
import parser from "./parser.reducer";
import modal from "./modal.reducer";
import certification from "./certification.reducer";
import didyoumean from "./didyoumean.reducer";
import profile from "./profile.reducer";
import search from "./search.reducer";
import nearby from "./nearby.reducer";
import srp from "./srp.reducer";
import askaquestion from "./askaquestion.reducer";
import individualagent from "./individualagent.reducer";
import team from "./team.reducer";
import udh from "./udh.reducer";
import hestiaSRP from "./hestiaSRP.reducer";
import linkingModules from "./linkingModules.reducer";
import geoLinks from "./geoLinks.reducer";
import featureFlags from "./featureFlags.reducer";
const rootReducer = combineReducers({
  parser,
  modal,
  certification,
  search,
  didyoumean,
  profile,
  nearby,
  srp,
  askaquestion,
  individualagent,
  team,
  udh,
  hestiaSRP,
  linkingModules,
  geoLinks,
  featureFlags,
});

export default rootReducer;
